export default {
  root: {
    width: '100%',
    height: 'auto',
    minHeight: 40,
  },
};
